import React from "react";

const LocalFilesFoldersSkeleton: React.FC = () => {
  return (
    <div className="flex-1 overflow-y-scroll scrollbar-hide animate-pulse">
      <div className="border-2 border-[#E4E7EC] rounded-lg overflow-hidden">
        {/* Header */}
        <div className="w-full bg-[#F9FAFB] flex items-center justify-between px-4 py-4">
          <div className="flex items-center space-x-3 min-w-0">
            <div className="w-6 h-6 bg-gray-200 rounded flex-shrink-0" />
            <div className="flex flex-col space-y-2">
              <div className="h-4 w-32 bg-gray-200 rounded" />
              <div className="h-3 w-20 bg-gray-200 rounded" />
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="h-10 w-20 bg-gray-200 rounded-md" />
            <div className="h-10 w-72 bg-gray-200 rounded-md" />
            <div className="h-8 w-8 bg-gray-200 rounded-md" />
          </div>
        </div>

        {/* Table */}
        <table className="w-full table-auto text-sm 2xl:text-base">
          <thead>
            <tr className="text-left border-b-2 border-[#f9fafb]">
              <th className="py-3 px-4">
                <div className="w-4 h-4 bg-gray-200 rounded" />
              </th>
              {["Document", "Type", "Size", "User", "Date", "Status"].map(
                (col) => (
                  <th key={col} className="py-3 px-4 text-slate-700">
                    <div className="h-4 w-20 bg-gray-200 rounded" />
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {[...Array(5)].map((_, idx) => (
              <tr
                key={idx}
                className="transition-colors duration-200 border-b-2 border-[#f9fafb] bg-white"
              >
                <td className="py-3 px-4">
                  <div className="w-4 h-4 bg-gray-200 rounded" />
                </td>
                <td className="py-3 px-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-7 h-7 bg-gray-200 rounded" />
                    <div className="w-40 h-4 bg-gray-200 rounded" />
                  </div>
                </td>
                <td className="py-3 px-4">
                  <div className="w-12 h-4 bg-gray-200 rounded" />
                </td>
                <td className="py-3 px-4">
                  <div className="w-14 h-4 bg-gray-200 rounded" />
                </td>
                <td className="py-3 px-4">
                  <div className="w-20 h-4 bg-gray-200 rounded" />
                </td>
                <td className="py-3 px-4">
                  <div className="w-20 h-4 bg-gray-200 rounded" />
                </td>
                <td className="py-3 px-4">
                  <div className="w-12 h-4 bg-gray-200 rounded mx-auto" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LocalFilesFoldersSkeleton;
